import React, { FC } from 'react'

import { GenericFeedbackPage } from 'components'

import { usePrivacyPolicyAcceptanceError } from '../hooks/usePrivacyPolicyAcceptanceError'

export const PrivacyPolicyAcceptanceError: FC = () => {
  const { icon, iconColor, title, details, confirmButtonText, confirmButtonClickHandler } =
    usePrivacyPolicyAcceptanceError()

  return (
    <GenericFeedbackPage
      title={title}
      details={details}
      icon={icon}
      iconColor={iconColor}
      confirmButton={{
        text: confirmButtonText,
        onClick: confirmButtonClickHandler,
      }}
    />
  )
}
